import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Box,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import CreateUnitDialog from '../../../components/CreateUnitDialog';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import api from './../../../utils/api';

const ViewUnits = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const superAdminId = user?.id;

  const [units, setUnits] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const fetchUnits = async () => {
    try {
      const res = await api.get(`/api/units/get-all/${superAdminId}`);
      setUnits(res.data);
    } catch (err) {
      console.error('Error loading units:', err);
    }
  };

  useEffect(() => {
    fetchUnits();
  }, [superAdminId]);

  const handleDelete = async (unitId) => {
    const confirm = window.confirm(
      'Are you sure you want to delete this unit?'
    );
    if (!confirm) return;

    try {
      await api.delete(`/api/units/delete/${unitId}`);
      fetchUnits(); // reload after deletion
    } catch (err) {
      console.error('Delete failed:', err);
      alert('Failed to delete unit');
    }
  };

  return (
    <SuperAdminLayout>
      <Container
        maxWidth="screen"
        sx={{
          mt: 4,
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ width: 300 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h5">All Units</Typography>
            <Button variant="contained" onClick={() => setOpenDialog(true)}>
              + Create Unit
            </Button>
          </Box>

          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Unit Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {units.map((unit) => (
                  <TableRow key={unit._id}>
                    <TableCell>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleDelete(unit._id)}
                        sx={{ ml: 1 }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell>{unit.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>

          {/* 🔥 The Dialog */}
          <CreateUnitDialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            onCreated={fetchUnits}
          />
        </Box>
      </Container>
    </SuperAdminLayout>
  );
};

export default ViewUnits;
